export default __webpack_public_path__ + "static/featured-70eb1c5ca3e0d5228282184f09e23fe7.png";